import { getLanguage } from "@home/utils/common";
import {DEFAULT_NAME} from "./constant";
import {IUserFilterItem} from "./type";

// 生成筛选条件摘要
export const generateSummary = (filters: IUserFilterItem[], logic: string | 'AND' | 'OR', defaultName = DEFAULT_NAME, isEn = true): string => {
  if (!filters || filters.length === 0) {
    return defaultName;
  }
  const validFilters = filters?.filter((f) => 
    f?.field?.trim() && 
    f?.operator?.trim() && 
    f?.value !== undefined && 
    f?.value !== null
  );
  if (validFilters?.length === 0) {
    return defaultName;
  }
  const andName = getLanguage(isEn, 'And', '且');
  const orName = getLanguage(isEn, 'Or', '或');
  const summaryParts = validFilters?.map((filter) => {
    const {
      fieldType,
      field = '',
      name_en: fieldNameEn = '',
      name_cn: fieldNameCn = '',
      operator = '',
      operatorEn = '',
      operatorCn = '',
      value,
      valueEn,
      valueCn,
    } = filter;
    const fieldName = getLanguage(isEn, fieldNameEn, fieldNameCn) || field;
    const operatorName = getLanguage(isEn, operatorEn, operatorCn) || operator;
    const valueName = getLanguage(isEn, valueEn, valueCn) || value;
    let valueText = '';
    if (fieldType === 'date' || operator === 'between') {
      const [start, end] = value as [string, string];
      const operatorText = getLanguage(isEn, 'and', '至');
      valueText = `${start} ${operatorText} ${end}`;
    } else if (Array.isArray(value)) {
      valueText = valueName?.join(', ');
    } else {
      valueText = String(value || '');
    }
    if (operator === 'between') return  `${fieldName}: ${valueText}`;
    return `${fieldName} ${operatorName} ${valueText}`;
  });
  const logicText = logic === 'AND' ? andName : orName;
  return summaryParts.join(` ${logicText} `);
};